import { getSchema } from "@tiptap/core";
import { Bold } from "@tiptap/extension-bold";
import { Document } from "@tiptap/extension-document";
import { HardBreak } from "@tiptap/extension-hard-break";
import { HorizontalRule } from "@tiptap/extension-horizontal-rule";
import { Italic } from "@tiptap/extension-italic";
import { ListItem } from "@tiptap/extension-list";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Strike } from "@tiptap/extension-strike";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
import { Text } from "@tiptap/extension-text";
import { Underline } from "@tiptap/extension-underline";
import { Dropcursor } from "@tiptap/extensions";

import { Blockquote } from "./extensions/Blockquote";
import { BulletList } from "./extensions/BulletList";
import { Code } from "./extensions/Code";
import { CodeBlock } from "./extensions/CodeBlock";
import { CustomBlock } from "./extensions/CustomBlock";
import { Heading } from "./extensions/Heading";
import { Image } from "./extensions/Image";
import { InlineExpression } from "./extensions/InlineExpression";
import { InlineMathIndentation } from "./extensions/InlineMathIndentation";
import { Link } from "./extensions/Link";
import { Mention } from "./extensions/Mention";
import { OrderedList } from "./extensions/OrderedList";
import { Table } from "./extensions/Table";
import { TableCell } from "./extensions/TableCell";
import { TableCellBackgroundColor } from "./extensions/TableCellBackgroundColor";
import { TableCellVerticalAlignment } from "./extensions/TableCellVerticalAlignment";
import { TableHeader } from "./extensions/TableHeader";
import { TableRow } from "./extensions/TableRow";
import { TailwindTextStyle } from "./extensions/TailwindTextStyle";
import { TaskItem } from "./extensions/TaskItem";
import { TaskList } from "./extensions/TaskList";
import { VariableLink } from "./extensions/VariableLink";

import type { Extension } from "@tiptap/core";

/**
 * Generates a Tiptap schema with a predefined set of extensions.
 *
 * NOTE: this schema should define everything not related to React/custom node views or user input handling.
 *
 * Define methods like `addAttributes`, `addOptions`, `renderHTML` here
 * and methods like `addCommands`, `addKeyboardShortcuts`, `addNodeView` in the editor setup.
 */
export function getChatSchema() {
  // {
  //   getNodeJson,
  //   serializeNode
  // }: Partial<InlineExpressionOptions> = {}
  return getSchema([
    // Document structure
    Document,

    // Text and inline marks
    Text,
    Paragraph,
    HardBreak,
    TailwindTextStyle,
    Underline,
    Subscript,
    Superscript,
    Strike,
    Code,
    Dropcursor,
    Link,
    VariableLink,
    Bold,
    InlineExpression,
    Italic,
    InlineMathIndentation,
    Mention,

    // Block nodes
    Heading,
    Blockquote,
    CodeBlock,
    BulletList,
    OrderedList,
    TaskList,
    ListItem,
    TaskItem,

    // Media
    Image,

    // Tables
    Table,
    TableRow,
    TableHeader,
    TableCell,
    TableCellBackgroundColor,
    TableCellVerticalAlignment,

    // Misc block nodes
    HorizontalRule,

    // Custom blocks (tool status, etc.)
    CustomBlock,
  ] as Extension[]);
}
